var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 1.00000004073083;
var op = 120.0000048877;
var w = 467;
var h = 467;
var nm = "caution  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Dot 3",
        sr: 0.98544232922732,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    274.336,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    360,
                    360,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -0.333
                                    ],
                                    [
                                        0,
                                        0.333
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 4.2,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Dot",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 27.0000010997325,
        op: 907.000036942867,
        st: 20.1019045141761,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Line 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    218.669,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    360,
                    360,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 27,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    0,
                                                    -19.458
                                                ],
                                                [
                                                    0,
                                                    17.583
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 29.0000011811942,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    0,
                                                    -6.333
                                                ],
                                                [
                                                    0,
                                                    6.333
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tm",
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 25,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 27,
                                    s: [
                                        50
                                    ]
                                },
                                {
                                    t: 29.0000011811942,
                                    s: [
                                        0
                                    ]
                                }
                            ],
                            ix: 1
                        },
                        e: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667
                                        ],
                                        y: [
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            1
                                        ],
                                        y: [
                                            0.012
                                        ]
                                    },
                                    t: 21,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    t: 26.0000010590017,
                                    s: [
                                        100
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        o: {
                            a: 0,
                            k: 0,
                            ix: 3
                        },
                        m: 1,
                        ix: 2,
                        nm: "Trim Paths 1",
                        mn: "ADBE Vector Filter - Trim",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 4.2,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Line",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Triangle 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    231.336,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    360,
                    360,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -4.597,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        2.299,
                                        4
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        2.298,
                                        -4
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        4.597,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -2.299,
                                        -4
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -2.299,
                                        4
                                    ]
                                ],
                                v: [
                                    [
                                        -20.686,
                                        24
                                    ],
                                    [
                                        20.686,
                                        24
                                    ],
                                    [
                                        25.858,
                                        15
                                    ],
                                    [
                                        5.172,
                                        -21
                                    ],
                                    [
                                        -5.171,
                                        -21
                                    ],
                                    [
                                        -25.858,
                                        15
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.658823549747,
                                0.46274510026,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 4.2,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Triangle",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    1
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 7,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 23.0000009368092,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: -127,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Circle 2",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    360,
                    360,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        35.346
                                    ],
                                    [
                                        35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        -35.346
                                    ]
                                ],
                                o: [
                                    [
                                        35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        -35.346
                                    ],
                                    [
                                        -35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        35.346
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        64
                                    ],
                                    [
                                        64,
                                        0
                                    ],
                                    [
                                        0,
                                        -64
                                    ],
                                    [
                                        -64,
                                        0
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.96862745285,
                                0.917647063732,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Circle",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Caution = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Caution as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Caution.json.es.js.map
